import * as helper from './helper';
import Paytour from './paytour/PaytourHelper';

export function chatFrameHandler(ab1: number = 0) {
	const button = helper.$('#startbutton');

	if (button !== null) {
		const paytour = new Paytour();

		helper.addEventListener(window, 'message', (e:MessageEvent) => {
			console.log(e);
			if (e.data.action && e.data.action === 'open sesame') {
				paytour.openPaytour({
					adtv: e.data.adtv,
					host: e.data.host,
					pfm: 1502,
					hideClose: false,
					option: '2XITGA'
				})
			}
		})

		const sizeCalculator = () => {
			const width = Math.min(Math.round(window.innerWidth * 0.95), 970);
			const height = Math.min(Math.round(window.innerHeight * 0.95), 600);

			return [width, height];
		}

		const resizeHandler = () => {
			const iframe:HTMLIFrameElement = helper.$('#camchatframe');
			if (iframe !== null) {
				const [width, height] = sizeCalculator();
				iframe.width = width + 'px';
				iframe.height = height + 'px';
			}
		}

		helper.addEventListener(window, 'resize', resizeHandler);

		helper.addEventListener(button, 'click', () => {
			const holder = helper.$('#camchatframeBlocker');
			if (holder === null) {
				const age = helper.getData(button, 'age');
				const url = helper.getData(button, 'url');

				const [width, height] = sizeCalculator();
				const iframe = `<div id="camchatframeBlocker"><div id="camchatframeHolder"><div id="close">X</div><iframe id="camchatframe" src="${url}&age=${age}&txt=Jetzt live chatten&muted=1&bonus=2XITGA&ab1=${ab1}" width="${width}" height="${height}"></iframe></div></div>`;

				window.document.body.append(helper.stringToHtml(iframe));

				helper.addEventListener(helper.$('#close'), 'click', () => {
					helper.remove(helper.$('#camchatframeBlocker'));
				})
			}
		});
	}
}
